import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 24px;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  border: 2px solid #59249B;
`;

export const Title = styled.h3`
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #59249B;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    font-size: 20px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px dashed #dee2e6;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const Label = styled.span`
  font-size: 14px;
  color: #495057;
`;

export const Value = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #333;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 2px solid #59249B;
`;

export const TotalLabel = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #59249B;
`;

export const TotalValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #59249B;
`;

export const AssistanceBadge = styled.span<{ isFree?: boolean }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  margin-left: 8px;
  background-color: ${props => props.isFree ? '#d4edda' : '#ffe5d0'};
  color: ${props => props.isFree ? '#155724' : '#c35a00'};
`;

export const PremiumInfo = styled.div`
  margin-top: 16px;
  padding: 12px;
  background-color: #fff;
  border-radius: 8px;
  border-left: 4px solid #59249B;
`;

export const PremiumRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
`;

export const PremiumLabel = styled.span`
  font-size: 13px;
  color: #666;
`;

export const PremiumValue = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #333;
`;

export const PremiumTotal = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: #59249B;
`;


